/* eslint-disable react/no-danger */
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
var PaymentCard = function PaymentCard(_ref) {
  var promote = _ref.promote,
    priceName = _ref.priceName,
    priceDescription = _ref.priceDescription,
    annualDescription = _ref.annualDescription,
    monthlyDescription = _ref.monthlyDescription,
    qualitiesTitle = _ref.qualitiesTitle,
    qualitiesAppendix = _ref.qualitiesAppendix,
    qualities = _ref.qualities,
    onSelectSubscription = _ref.onSelectSubscription;
  return /*#__PURE__*/React.createElement("div", {
    className: promote ? 'payment-card-container green-outline' : 'payment-card-container'
  }, promote ? /*#__PURE__*/React.createElement("div", {
    className: "payment-card-emphasis centered-content header-text"
  }, "BEST VALUE") : /*#__PURE__*/React.createElement("div", {
    className: "payment-card-emphasis-empty"
  }), /*#__PURE__*/React.createElement("div", {
    className: "payment-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payment-card-title header-text ".concat(promote ? 'squared-top-radius' : '')
  }, /*#__PURE__*/React.createElement("h2", null, priceName), /*#__PURE__*/React.createElement("p", {
    className: "payment-card-blurb"
  }, priceDescription)), /*#__PURE__*/React.createElement("div", {
    className: "payment-card-description"
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: annualDescription
    }
  }), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: monthlyDescription
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "payment-card-items"
  }, /*#__PURE__*/React.createElement("h3", null, qualitiesTitle), /*#__PURE__*/React.createElement("div", {
    className: "payment-card-line-items"
  }, qualities.map(function (quality) {
    return /*#__PURE__*/React.createElement("div", {
      className: "payment-card-item body-text",
      key: quality
    }, /*#__PURE__*/React.createElement(Icon, {
      size: "large",
      name: "check",
      className: "payment-card-item-icon"
    }), /*#__PURE__*/React.createElement("p", null, quality));
  })), /*#__PURE__*/React.createElement("div", {
    className: "payment-card-appendix"
  }, qualitiesAppendix.map(function (qualityAppendix) {
    return /*#__PURE__*/React.createElement("div", {
      key: qualityAppendix
    }, /*#__PURE__*/React.createElement("p", null, qualityAppendix));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "payment-card-cta"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "select",
    content: "Select Plan",
    onClick: onSelectSubscription
  }))));
};
PaymentCard.defaultProps = {
  qualitiesAppendix: [],
  promote: false
};
export default PaymentCard;